import { ROUTES } from "@shared/constants/routes";
import { useIonRouter } from "@ionic/react";
import { AppNavbar } from "@shared/ui/AppNavbar";
import { InfoGlyph } from "./profile-glyphs";

interface ProfileTopBarProps {
  onInfoClick: () => void;
}

export const ProfileTopBar = ({ onInfoClick }: ProfileTopBarProps) => {
  const nav = useIonRouter();

  return (
    <AppNavbar
      logoAriaLabel="Открыть главный экран"
      logoTap={{ enabled: false }}
      onLogoClick={() => {
        nav.push(ROUTES.overall.main);
        return true;
      }}
      rightSlot={
        <button
          type="button"
          aria-label="О приложении"
          onClick={onInfoClick}
          className="flex size-[48px] items-center justify-center rounded-full text-[#2F3337] transition-transform active:scale-[0.96] [-webkit-tap-highlight-color:transparent] focus:outline-none focus-visible:ring-2 focus-visible:ring-black/[0.08] focus-visible:ring-offset-2 focus-visible:ring-offset-[#FBFBFA]"
        >
          <InfoGlyph className="size-[30px]" />
        </button>
      }
    />
  );
};
